var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"text-center",on:{"click":function($event){return _vm.$emit(_vm.action)}}},[_c('span',{staticClass:"text-sm tracking-base",class:{ 'is-disabled': _vm.isDisabled }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }